import styled from 'styled-components'
import { colors } from '../../theme'

// export const Img = styled.img`
//   max-width: 834px;
//   height: 100vh;
// `
export const RealizeSeuLogin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${colors.grey100};
`
// export const Wrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
//   margin: 0 auto;
// `
export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 40px auto;
  background-color: ${colors.login};
  box-shadow: 0 18px 48px ${colors.overlay};
  border-radius: 20px;
  color: ${colors.white};
  width: 400px;
  padding: 40px;
  gap: 14px;
`

/* Mesma regua do cartao de login: 14px de gap entre os campos, que somados a
   margem propria do Input dao os mesmos 28px de borda a borda. */
export const NovaSenha = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 6px;

  span {
    color: ${colors.help};
    font-size: 12px;
    margin-top: 5px;
    font-weight: 400;
  }
`

export const Info = styled.div`
  color: ${colors.white};
  font-size: 12px;
  margin-top: 25px;
  margin-left: 5px;
  font-weight: 400;
`
